import { flatten } from 'lodash'

import { legalEntityEmployeeGroups } from 'modules/employees/store/collections/employeeGroups'

import { companyLegalEntities, employeeGroupLegalEntity } from 'modules/core/store/collections/legalEntities'
import { Company } from 'modules/core/store/models/Company'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

/**
 * Product needs to review how we decide what's
 * the country code used to show currency
 * to the logged user. For now we check legalEntity
 * with fallback to first legalEntity for admins
 */

export const companyCurrentIsoCountry = (company: Company) => {
  return employeeGroupLegalEntity(companyMainEmployeeGroup(company)).attributes.country
}

const companyEmployeeGroups = (company: Company) => {
  return flatten(
    companyLegalEntities(company).flatMap((legalEntity: LegalEntity) =>
      legalEntityEmployeeGroups(legalEntity)
    )
  )
}

const companyMainEmployeeGroup = (company: Company) => {
  const companyGroups = companyEmployeeGroups(company)
  const employeeGroup = companyGroups.find((group) => !!group.attributes.main) || companyGroups[0]

  if (!employeeGroup) throw Error('Company without main employee group')

  return employeeGroup
}
